// extracted by mini-css-extract-plugin
export var image = "cl01v";
export var main = "m9Uru";
export var text = "o5Rqe";
export var title = "KoiU9";